/**
 * Сервис для работы с ресторанами
 */

import api from './api';
import { Restaurant } from '../types/api';

export interface RestaurantSuggestions {
  suggestions: string[];
  count: number;
}

export interface RestaurantsResponse {
  restaurants: Restaurant[];
}

class RestaurantService {
  /**
   * Получает предложения ресторанов из файла (legacy)
   */
  async getRestaurantSuggestions(): Promise<RestaurantSuggestions> {
    return await api.get('/suggest/restaurants');
  }

  /**
   * Получает список ресторанов из базы данных
   */
  async getRestaurants(): Promise<RestaurantsResponse> {
    return await api.get('/restaurants/');
  }
}

export const fetchRestaurants = async (): Promise<{ restaurants: Restaurant[] }> => {
  const service = new RestaurantService();
  const response = await service.getRestaurants();
  return { restaurants: response.restaurants };
};

export const getRestaurantById = (restaurants: Restaurant[], id: string) => {
  return restaurants.find(r => r.restaurant_id === id);
};

export default new RestaurantService();
